module.exports = __webpack_public_path__ + "400815a5f1ce1d2155b27a4a9e2318cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/facebook_2020_chart.png
// module id = 1673
// module chunks = 0